import { useGT } from 'gt-react';
import type { SalesHistoryTransferModeInput } from '@erp/rpc';
import { Badge } from 'src/components/ui/badge';

export function TransferModeBadge({
  mode,
}: {
  mode: SalesHistoryTransferModeInput;
}) {
  const gt = useGT();
  return (
    <Badge variant={mode === 'transfer' ? 'default' : 'secondary'}>
      {mode === 'transfer'
        ? gt('Transfer', { context: 'sales history transfer mode badge' })
        : gt('Copy', { context: 'sales history copy mode badge' })}
    </Badge>
  );
}
